import { GripVertical } from 'lucide-react';

/**
 * EventPill — a single draggable event chip inside a day cell.
 * Deduplicates the identical markup that appeared inline in both the
 * month and week views (was ~40 lines duplicated). `variant` controls
 * gripper visibility (always-shown in the week view).
 */
export const EventPill = ({
  event,
  propertyColorMap,
  onEventClick,
  onDragStart,
  onDragEnd,
  showPropertyName,
  variant = 'month', // 'month' | 'week'
  testIdPrefix = 'event',
}) => {
  const gripClasses =
    variant === 'week'
      ? 'h-3 w-3 opacity-50 flex-shrink-0'
      : 'h-3 w-3 opacity-0 group-hover/event:opacity-50 flex-shrink-0';

  return (
    <div
      draggable
      onDragStart={(e) => {
        e.stopPropagation();
        onDragStart(e, event);
      }}
      onDragEnd={onDragEnd}
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onEventClick(event);
      }}
      className={`event-pill ${event.type} cursor-pointer active:cursor-grabbing flex items-center gap-1 group/event`}
      style={{ borderLeft: `4px solid ${propertyColorMap[event.property_id] || 'transparent'}` }}
      title={`${event.title}${event.property_name ? ' — ' + event.property_name : ''} — click for details, drag to reschedule`}
      data-testid={`${testIdPrefix}-${event.id}`}
    >
      <GripVertical className={gripClasses} />
      <span className="truncate">
        {event.title}
        {showPropertyName && event.property_name && (
          <span className="ml-1 opacity-70 font-normal">
            · {event.property_name}
          </span>
        )}
      </span>
    </div>
  );
};

export default EventPill;
